import { tokens } from "@/components/Application/theme";
import { Chip, ChipProps, styled } from "@mui/material";
import { ReactNode } from "react";

type Props = {
    label: ReactNode
};

const StyledChip = styled(({ ...props } : ChipProps & Props) => <Chip {...props} />)(({ theme }) => {
    const colors = tokens(theme.palette.mode);
    return {
        display: "flex",
        justifyContent: "space-between",
        verticalAlign: "center",
        width: "fit-content",
        transition: ".2s all ease-in-out",
        position: "relative",
        overflow: "hidden",
    }
});

export const SatosLiveTagChip: React.FC<ChipProps & Props> = (props) => {
    return <StyledChip {...props} />;
}